import { render, staticRenderFns } from "./CardProcesso.vue?vue&type=template&id=a73337a8&scoped=true"
import script from "./CardProcesso.vue?vue&type=script&lang=js"
export * from "./CardProcesso.vue?vue&type=script&lang=js"
import style0 from "./CardProcesso.vue?vue&type=style&index=0&id=a73337a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73337a8",
  null
  
)

export default component.exports